/**
 * @todo add/update JSDoc tags to document your code
 * (see http://usejsdoc.org/ for information on JSDoc tags),
 * then remove this comment block.
 */

/** WholeClass Redux (class-based) component */
import React, { Component } from 'react';
import styleable from 'react-styleable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import queryString from 'querystring';
import '../../styles/core.scss';
import css from './whole-class.scss';
import {
    actionCreator, setupPortal, getAllData, updateTitle, setupButtons, selectClass, selectGroup, unassignStudent,
    checkboxSelect, passwordUpdate, navigateBtnClick, endPasswordRevertBack, downloadSignInCards, resetClickActionType
}
    from './whole-class-actions';
import { showConfirmation } from '../../containers/confirmation-modal/confirmation-modal-actions';
import ClassGroupSelector from '../../components/class-group-selector/class-group-selector';
import ContentBox from '../../components/content-box/content-box';
import StudentsTable from '../../components/students-table/students-table';
import PageButton from '../../components/page-button/page-button';
import SvgIcon from '../../components/svg-icon/svg-icon';
import Text from './whole-class-text';
import Modal from '../../components/modal';
import SignInCardsFormats from '../../components/sign-in-cards-formats';

/**
 * WholeClass Redux component. @todo expand this description.
 * Receives properties via 'props'
 */
@styleable(css)
class WholeClass extends Component {
    /** @todo define the types of each prop */
    static propTypes = {
        /** @todo use the props declared below and remove the eslint directive on the next line */
        /* eslint react/no-unused-prop-types: 0 */
        setupPortal: PropTypes.func,
        location: PropTypes.object,
        history: PropTypes.object,
        getAllData: PropTypes.func,
        updateTitle: PropTypes.func,
        setupButtons: PropTypes.func,
        selectClass: PropTypes.func,
        selectGroup: PropTypes.func,
        checkboxSelect: PropTypes.func,
        passwordUpdate: PropTypes.func,
        wholeClassReducer: PropTypes.object,
        navigateBtnClick: PropTypes.func,
        showConfirmation: PropTypes.func,
        unassignStudent: PropTypes.func,
        productId: PropTypes.any,
        endPasswordRevertBack: PropTypes.func,
        downloadSignInCards: PropTypes.func,
        resetClickActionType: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.manageNavigateBtns = [
            {
                label: 'Manage students',
                action: 'manage-students',
                toUrl: '/students',
                data: {}
            }
        ];

        this.state = {
            showModal: false
        };

        this.showModal = true;
        this.leftButtons = [];
        this.rightButtons = [];

        this.passwordRevertNoticer = { inform: undefined };
    }

    componentDidUpdate() {
        const { productId } = this.props;
        const {
            clickActionType, unassignCommandInfo, redoUpdateGroup, studentSum, needFootBtnSetup,
            studentList, selectedClassId, selectedGroupId, passwordRevertBack
        } = this.props.wholeClassReducer;
        if (clickActionType && clickActionType === 'BTN_UNASSIGN') {
            const bePlural = ((WholeClass.getSelectedStudentUserProfileIds(studentList) || []).length > 1);
            this.props.showConfirmation({ type: 'display-unassign', bePlural });
        } else if (unassignCommandInfo && unassignCommandInfo === 'unassign') {
            const studentUserProfileIdsToUnassign = WholeClass.getSelectedStudentUserProfileIds(studentList);
            this.props.unassignStudent(studentUserProfileIdsToUnassign, productId, selectedClassId, selectedGroupId);
        } else if (redoUpdateGroup) {
            // currently the response of getTeacherClassMgmtUnassignStudent is designed to be not required to
            // have information of current "selected GroupId" neither provide the selected group students, need
            // front end to readjustment for work out this.
            this.props.selectGroup({ classId: selectedClassId }, { groupId: selectedGroupId }, productId);
        } else if (passwordRevertBack) {
            if (typeof this.passwordRevertNoticer.inform === 'function') {
                this.passwordRevertNoticer.inform();
            }
            this.prevPasswordUpdateInfo = undefined;
            this.props.endPasswordRevertBack();
        } else if (clickActionType && clickActionType === 'BTN_DOWNLOAD') {
            this.handleOnShowHideModal(true);
        }

        if (needFootBtnSetup) {
            this.rightButtons[0].data.disabled = !(studentSum.checkboxCount);
            this.rightButtons[1].data.disabled = !(studentSum.checkboxCount);
            this.props.setupButtons(this.leftButtons, this.rightButtons);
        }
    }

    static getSelectedStudentUserProfileIds(students) {
        const studentUserProfileIdsToUnassign = [];

        students.forEach((student) => {
            if (student.selected) {
                studentUserProfileIdsToUnassign.push(student.userProfileId);
            }
        });

        return studentUserProfileIdsToUnassign;
    }

    passwordUpdateCheck(updateInfo) {
        let toForwardUpdate = false;
        if (!this.prevPasswordUpdateInfo) {
            this.prevPasswordUpdateInfo = updateInfo;
            toForwardUpdate = true;
        } else if (this.prevPasswordUpdateInfo && this.prevPasswordUpdateInfo.student &&
            (this.prevPasswordUpdateInfo.newPassword !== updateInfo.newPassword ||
                this.prevPasswordUpdateInfo.student.userProfileId !== updateInfo.student.userProfileId)) {
            this.prevPasswordUpdateInfo = updateInfo;
            toForwardUpdate = true;
        }

        if (toForwardUpdate) {
            this.props.passwordUpdate(updateInfo);
        }
    }

    componentDidMount() {
        // disable portal spinner as soon as this component mounts
        this.props.setupPortal(false);

        this.props.updateTitle('Classes', 'WHOLE CLASS');
        const { classList, selectedClassId } = this.props.wholeClassReducer;
        if (typeof classList === 'undefined') {
            const { productId } = this.props;
            const query = this.props.location.search;
            const queryStr = query.replace('?', '');
            let { classId, groupId } = queryString.parse(queryStr);
            if (!classId) {
                classId = selectedClassId;
            }
            if (!groupId) {
                groupId = 0;
            }

            this.props.getAllData(productId, classId, groupId);
        }

        const leftButtons = [];
        const rightButtons = [
            {
                label: 'Download',
                action: 'BTN_DOWNLOAD',
                data: { disabled: true }
            },
            {
                label: 'Unassign',
                action: 'BTN_UNASSIGN',
                data: { disabled: true }
            }
        ];
        this.leftButtons = leftButtons;
        this.rightButtons = rightButtons;
        this.props.setupButtons(leftButtons, rightButtons);
    }

    handleOnShowHideModal = (status) => {
        this.setState({ showModal: status });
        this.props.resetClickActionType();
    }

    handleOnDownloadSignInCards = (format) => {
        const { productId } = this.props;
        const {
            studentList, selectedClassId, selectedGroupId
        } = this.props.wholeClassReducer;
        const StudentUserProfileIds = WholeClass.getSelectedStudentUserProfileIds(studentList);
        this.props.downloadSignInCards(StudentUserProfileIds, productId, selectedClassId, selectedGroupId, format);
        this.handleOnShowHideModal(false);
    }

    render() {
        const { productId } = this.props;
        const {
            classList, groupList, studentList, studentSum,
            selectedClassId, selectedGroupId
        } = this.props.wholeClassReducer;

        const selectedClass = { classId: selectedClassId, name: '' };
        const selectedGroup = { groupId: selectedGroupId, name: '' };

        if (studentSum && isNaN(studentSum.checkboxSum) && studentList) {
            studentSum.checkboxSum = studentList.length;
            studentSum.checkboxCount = 0;
        }

        const manageNavigateBtnsDoms = this.manageNavigateBtns.map(item =>
            (<PageButton
                key={item.label}
                onClick={
                    () => this.props.navigateBtnClick(this.props.history, item, {
                        classId: selectedClassId,
                        groupId: selectedGroupId
                    })
                }>
                {Text[item.label]}
            </PageButton>)
        );

        const getContentDoms = () => {
            let contentDoms;
            if (classList && classList.length > 0) {
                contentDoms = (
                    <ContentBox flowType="column">
                        <div className={css['row-section-up']}>
                            <ClassGroupSelector
                                selectedClassId={selectedClass.classId}
                                selectedGroupId={selectedGroup.groupId}
                                classList={classList}
                                groupList={groupList}
                                onClassChange={(classItem) => {
                                    this.props.selectClass(classItem, productId);
                                }}
                                onGroupChange={(groupItem) => {
                                    this.props.selectGroup(
                                        selectedClass, groupItem, productId);
                                }}
                            />
                            <div className={css['navigate-btn-right-side']}>
                                {manageNavigateBtnsDoms}
                            </div>
                        </div>
                        <div className={css['row-section-low']}>
                            <StudentsTable
                                studentList={studentList}
                                studentSum={studentSum}
                                checkClick={(selectedInfo) => {
                                    this.props.checkboxSelect(selectedInfo);
                                }}
                                passwordUpdate={(updateInfo) => {
                                    this.passwordUpdateCheck(updateInfo);
                                }}
                                passwordRevertNoticer={this.passwordRevertNoticer} />
                        </div>
                    </ContentBox>
                );
            } else {
                contentDoms = (
                    <div className={css['empty-class-box']}>
                        <div className={css['circle-dim']}>
                            <SvgIcon
                                type="no-classes"
                            />
                        </div>
                        <div className={css['text-box']}>
                            <p className={`${css['text-style']} text`}>{Text.NoClasses}</p>
                            <p>{Text.admin}</p>
                        </div>
                    </div>
                );
            }
            return contentDoms;
        };

        return (
            <div>
                <div className={css['whole-class']}>
                    {getContentDoms()}
                </div>
                <Modal show={this.state.showModal}>
                    <SignInCardsFormats
                        handleOnCancel={() => this.handleOnShowHideModal(false)}
                        handleOnDownloadSignInCards={this.handleOnDownloadSignInCards}
                    />
                </Modal>
            </div>
        );
    }
}

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from WholeClassCombinedReducers.
 */
function mapStateToProps(state) {
    return {
        wholeClassReducer: state.wholeClassReducer
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    /**
     * @todo ensure that 'actionCreator' below matches the name
     * of the corresponding action creator function in whole-class-actions.js,
     * and add an action creator entry for each action the component uses.
     */
    return bindActionCreators({
        setupPortal,
        updateTitle,
        setupButtons,
        actionCreator,
        selectClass,
        selectGroup,
        checkboxSelect,
        getAllData,
        passwordUpdate,
        navigateBtnClick,
        showConfirmation,
        unassignStudent,
        endPasswordRevertBack,
        downloadSignInCards,
        resetClickActionType
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(WholeClass);



// WEBPACK FOOTER //
// ./containers/whole-class/whole-class.js